import { doDelete, doGet, doPut } from "./http.service";
import { QuickLogin } from "../types/QuickLogin";
import { Page } from "../types/Page";

export interface QuickLoginFilter {
    page: number,
    size: number,
    phone: string,
    sortKey: string,
    sortOrder: 'asc' | 'desc',
}

export function loadQuickLogins(filter:QuickLoginFilter) {
    return doGet<Page<QuickLogin>>("/quick-logins", {params: filter});
}
export function deleteQuickLogins(id:string) {
    return doDelete<void>("/quick-logins/" + id);
}
export function updateQuickLogins(id:string, payload:QuickLogin) {
    return doPut<QuickLogin>("/quick-logins/" + id, payload);
}